export default "__VITE_ASSET__Dyru_w9H__"